import { useMutation } from '@tanstack/react-query';

import { GET_PROMPT_VARIABLES_QUERY_KEY } from './useGetPromptVariables';

import { queryClient } from '@/lib/queryClient';
import PromptsService, {
  CreatePromptVariableDto,
  FilterPromptVariablesDto,
} from '@/services/PromptsService';

export function useCreatePromptVariable(filters: FilterPromptVariablesDto) {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (createPromptVariableDto: CreatePromptVariableDto) =>
      PromptsService.createPromptVariable(createPromptVariableDto),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: GET_PROMPT_VARIABLES_QUERY_KEY(filters),
      });
    },
  });

  return {
    createPromptVariable: mutateAsync,
    isLoading: isPending,
  };
}
